import React from 'react';
import type { PreviewColorScheme } from '../WebsitePreview';

const BlogPreview: React.FC<{ scheme: PreviewColorScheme }> = ({ scheme }) => (
  <div style={{ fontFamily: 'Inter, system-ui, sans-serif', fontSize: '12px' }}>
    {/* Nav */}
    <nav
      style={{ backgroundColor: scheme.surface, borderBottom: `1px solid ${scheme.border}`, padding: '10px 20px' }}
      className="flex items-center justify-between"
    >
      <div style={{ color: scheme.text, fontWeight: 700, fontSize: '14px' }}>Sample blog</div>
      <div className="flex gap-4">
        {['Articles', 'Categories', 'About'].map(t => (
          <span key={t} style={{ color: scheme.textMuted, fontSize: '11px' }}>{t}</span>
        ))}
      </div>
    </nav>

    {/* Featured Post */}
    <div style={{ padding: '20px' }}>
      <div style={{ backgroundColor: scheme.surface, border: `1px solid ${scheme.border}`, borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ height: '80px', background: `linear-gradient(135deg, ${scheme.primary}22, ${scheme.secondary}22)` }} />
        <div style={{ padding: '14px' }}>
          <span style={{ backgroundColor: scheme.primary, color: '#fff', fontSize: '9px', fontWeight: 600, padding: '2px 8px', borderRadius: '20px' }}>
            Featured
          </span>
          <h2 style={{ color: scheme.text, fontWeight: 700, fontSize: '16px', margin: '8px 0 4px', lineHeight: 1.3 }}>
            Understanding Color Theory in Modern Web Design
          </h2>
          <p style={{ color: scheme.textMuted, fontSize: '11px', lineHeight: 1.5, marginBottom: '8px' }}>
            Sample article copy shows how your palette looks on headings, labels and reading surfaces.
          </p>
          <div className="flex items-center gap-2">
            <div style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: scheme.secondary, opacity: 0.7 }} />
            <span style={{ color: scheme.textMuted, fontSize: '10px' }}>Sample author · 5 min read</span>
          </div>
        </div>
      </div>

      {/* Post Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', marginTop: '14px' }}>
        {[
          { title: 'Accessibility First Design', tag: 'Design', time: '3 min' },
          { title: 'CSS Color Functions Guide', tag: 'Code', time: '7 min' },
        ].map(post => (
          <div key={post.title} style={{ backgroundColor: scheme.surface, border: `1px solid ${scheme.border}`, borderRadius: '8px', padding: '12px' }}>
            <div style={{ height: '40px', borderRadius: '4px', backgroundColor: `${scheme.secondary}15`, marginBottom: '8px' }} />
            <span style={{ color: scheme.secondary, fontSize: '9px', fontWeight: 600, textTransform: 'uppercase' as const }}>
              {post.tag}
            </span>
            <div style={{ color: scheme.text, fontWeight: 600, fontSize: '12px', margin: '4px 0', lineHeight: 1.3 }}>{post.title}</div>
            <span style={{ color: scheme.textMuted, fontSize: '10px' }}>{post.time} read</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default BlogPreview;
